import { NgModule } from '@angular/core';
import { AngularEchartsDirective } from './directive/angular-echarts.directive';
export * from './directive/angular-echarts.directive';
var AngularEchartsModule = (function () {
    function AngularEchartsModule() {
    }
    return AngularEchartsModule;
}());
export { AngularEchartsModule };
AngularEchartsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    AngularEchartsDirective
                ],
                exports: [
                    AngularEchartsDirective
                ]
            },] },
];
AngularEchartsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/ngx-echarts/index.js
// module id = ../../../../ngx-echarts/index.js
// module chunks = common